import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Modal } from 'bootstrap';
import { Rep, RoutineModelExercise } from 'src/app/interfaces/exercise';
import { RoutineModel } from 'src/app/interfaces/routine';
import { RoutineService } from 'src/app/services/routine.service';
import { StateService } from 'src/app/services/state.service';
import { TabletRoutinesService } from 'src/app/services/tablet-routines.service';

@Component({
  selector: 'app-tablet-routine',
  templateUrl: './tablet-routine.component.html',
  styleUrls: ['./tablet-routine.component.scss'],
})
export class TabletRoutineComponent implements OnInit {
  routineId?: string;
  routine?: RoutineModel;
  tabletRoutine: any;
  exercisesByExerciseGroup: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private routineService: RoutineService,
    private stateService: StateService,
    private tabletRoutinesService: TabletRoutinesService
  ) {}

  ngOnInit(): void {
    this.routineId = this.route.snapshot.paramMap.get('routineId')!;
    this.tabletRoutine = this.stateService.selectedTabletRoutine;
    if (!this.tabletRoutine) {
      this.router.navigate(['/home-tablet']);
    }

    this.getRoutine();
  }

  getRoutine() {
    this.routineService
      .getRoutineModelTablet(parseInt(this.routineId!))
      .subscribe({
        next: (res: any) => {
          this.routine = res;

          this.groupExercisesByExerciseGroup();
        },
      });
  }

  finishRoutine() {
    if (window.confirm('¿Estás seguro de que deseas finalizar la rutina?')) {
      this.tabletRoutinesService
        .finishAutoAssignedRoutine(this.tabletRoutine.id)
        .subscribe({
          next: (res: any) => {
            this.router.navigate(['/home-tablet']);
          },
        });
    }
  }

  getIntensityPrinciplesByExercise() {
    this.tabletRoutine?.exercises.forEach((exercise: RoutineModelExercise) => {
      let exerciseIntensityPrinciples: string[] = [];

      exercise.reps.forEach((rep: Rep) => {
        if (rep.intensityPrinciples) {
          rep.intensityPrinciples.forEach((ip: string) => {
            if (
              exerciseIntensityPrinciples.filter((IP) => IP == ip).length == 0
            ) {
              exerciseIntensityPrinciples.push(ip);
            }
          });
        }
      });

      exercise.intensityPrinciples = exerciseIntensityPrinciples;
    });
  }

  groupExercisesByExerciseGroup() {
    let counter: number = 0;
    let exercisesByExerciseGroup: any = [];
    let exerciseGroup: any = [];

    do {
      counter++;

      exerciseGroup = this.routine?.exercises?.filter(
        (e: any) => e.exerciseGroup == counter
      );

      exerciseGroup = exerciseGroup ? exerciseGroup : [];

      exerciseGroup.length > 0
        ? exercisesByExerciseGroup.push(exerciseGroup)
        : {};
    } while (exerciseGroup.length > 0);

    this.exercisesByExerciseGroup = exercisesByExerciseGroup;
  }

  async openVideoModal(exercise: RoutineModelExercise) {
    if (exercise.exercise!.shortVideo.id) {
      this.stateService.selectedTabletTutorialId =
        exercise.exercise!.shortVideo.id;

      const modal = new Modal('#videoModal');
      this.stateService.openModal = modal;

      modal.show();
    } else {
      window.alert('Este ejercicio no tiene tutoriales aún');
    }
  }
}
